SCM = SCM || {};
SCM.SessionDiagnostics = (function ($) {
    return {
        init: init
    };

    function init() {
        $(document).on('click', '.js-session-diagnostics-submit-btn', function () {
            submitSessionDiagnosticsEmail();
        });
    }

    function submitSessionDiagnosticsEmail() {
        var $submitBtn = $('.js-session-diagnostics-submit-btn');
        var $formContainer = $('.session-diagnostics');
        var captchaResponse = SCM.Captcha.GetCaptchaResponse($formContainer);
        var captchaWidgetInstanceName = SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId;
        $submitBtn.addClass('disabled');
        var url = '/OUP/SendSessionDiagnosticsEmail';

        SCM.Ajax.post(url, { captchaResponse: captchaResponse, captchaInstanceName: captchaWidgetInstanceName })
            .then(function (result) {
                if (result === 'false') {
                    window.location.reload();
                }
                else {
                    $submitBtn.removeClass('disabled');
                }
            });
    }
})(jQuery);